import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Componentes del módulo
import { BotonNotificacionesComponent } from './boton-notificaciones.component';

// 🔥 CORRECCIÓN: Importar todos los módulos de Angular Material necesarios
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    BotonNotificacionesComponent
  ],
  imports: [
    CommonModule, // Necesario para directivas como *ngIf, *ngFor, ngClass
    RouterModule,
    
    // 🔥 CORRECCIÓN: Añadir los módulos importados aquí
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDividerModule,
  ],
  exports: [
    BotonNotificacionesComponent
  ]
})
export class NotificacionesModule { }